import { useSearchParams } from 'react-router';

/**
 * Pestaña elegida guardada en la dirección (?tab=…): al recargar la página o compartir el enlace
 * se abre en la misma pestaña. Un valor desconocido vuelve a la primera.
 */
export function useTabParam<T extends string>(tabs: readonly T[], name = 'tab'): [T, (tab: T) => void] {
  const [params, setParams] = useSearchParams();
  const current = params.get(name) as T | null;
  const tab = current && tabs.includes(current) ? current : tabs[0]!;
  const setTab = (next: T) =>
    setParams(
      (prev) => {
        const p = new URLSearchParams(prev);
        if (next === tabs[0]) p.delete(name);
        else p.set(name, next);
        return p;
      },
      { replace: true },
    );
  return [tab, setTab];
}
